import React from "react";

const STATUSES = [["", "All"], ["ready", "Completed"], ["running", "Running"], ["failed", "Failed"], ["cancelled", "Cancelled"]];
const RUNNING = ["queued", "ingesting", "composing"];

export const countFor = (counts, s) => (s === "running" ? RUNNING.reduce((n, k) => n + (counts?.[k] || 0), 0)
    : s ? counts?.[s] || 0 : Object.values(counts || {}).reduce((n, v) => n + v, 0));

/** Company + status filters of the study build list (companies / counts come from the list response). */
export default function StudyBuildFilters({ companies, counts, company, status, onCompany, onStatus, shown, canPickCompany }) {
    const total = countFor(counts, status);
    return (
        <div className="flex items-center gap-3 mb-4 flex-wrap" data-testid="study-build-filters">
            {canPickCompany && (
                <select value={company} onChange={(e) => onCompany(e.target.value)} data-testid="study-build-company-filter"
                    className="bg-[#0c0c10] border border-white/15 rounded-full px-3 py-1.5 text-xs text-white/80 focus:border-[#7C3AED]/60 outline-none">
                    <option value="">All companies</option>
                    {companies.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
            )}
            <div className="flex items-center gap-1">
                {STATUSES.map(([k, label]) => (
                    <button key={k || "all"} onClick={() => onStatus(k)} data-testid={`study-build-status-filter-${k || "all"}`}
                        className={`text-[11px] uppercase tracking-wider px-2.5 py-1 rounded-full border transition-colors ${status === k ? "border-[#7C3AED]/60 bg-[#7C3AED]/15 text-[#e2d4ff]" : "border-white/10 text-white/55 hover:border-white/25"}`}>
                        {label} <span className="tabular-nums opacity-70">{countFor(counts, k)}</span>
                    </button>
                ))}
            </div>
            <span className="text-[11px] text-white/40 ml-auto" data-testid="study-build-shown-count">
                Showing {shown} of {total}{shown < total ? " (newest first)" : ""}
            </span>
        </div>
    );
}
